<template>
  <div class="oneUser">
    <!--<van-nav-bar title="用户信息" left-arrow @click-left="onClickLeft" border />-->
    <!--<div class="bg-10px"></div>-->
    <div class="list-header">
      <div class="img-con">
        <img :src="oneMember.avatar ? (oneMember.avatar + '?imageView2/0/w/80/h/80') : checkQiNiuUrl('FtKRQqCkGtCCFLF_VQStosKgqOJP')" alt="">
        <span class="vip-icon" :class="'vip'+oneMember.platformMemberLevel"></span>
      </div>
      <div class="text-con">
        <p class="name">{{ oneMember.nickname || '' }}</p>
        <p class="date">{{ oneMember.username }}</p>
      </div>
    </div>

    <div class="bg-10px"></div>

    <div class="list-con">
      <p class="list-title">Ta的一级用户：<span class="blue">{{ memberNum.oneCount || 0 }}</span>人</p>
      <div class="list" v-for="(item, i) in levels" :key="'statL1-'+i">
        <div class="img-con">
          <div class="icon-img" :class="'icon-img-'+(i+1)"></div>
        </div>
        <div class="text-con">
          <p class="text">{{ item.memberName }}<span class="num">{{ memberNum[`platformLevelCount${i+1}`] }}</span>人</p>
            <!--，占比<span class="blue">{{ statL1[`lv${i+1}Percentage`]*100 | filter2 }}%</span>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { memberPlatformGrade } from '@/api/member'
import { getPlatformMemberChildLevel1Stat } from '@/api/member'
export default {
  components: {
  },
  data(){
    return {
      levels: [],
      oneMember: JSON.parse(window.localStorage.getItem('oneMember')),
      memberNum: {
        platformLevelCount1: 0,
        platformLevelCount2: 0,
        platformLevelCount3: 0,
        oneCount: 0 // Ta的一级用户数
      }
    }
  },
  created(){
    this.getMemberRank()
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    getOneUser(){
      getPlatformMemberChildLevel1Stat({userId: this.oneMember.userId}).then(res=>{
        // console.log(res.data)
        const { data } = res;
        this.memberNum.oneCount = data.childrenCount; // Ta的一级会员总数
        let levelStatList = data.levelStatList || [];
        levelStatList.forEach(item=>{
          this.memberNum['platformLevelCount'+item.platformMemberLevel] = item.cnt
        })

      })

    },

    //获取会员等级
    getMemberRank(){
      memberPlatformGrade({}).then(res => {
        this.levels = res.data.levels ||[];
        this.getOneUser()
      })
    },

  },
  beforeDestroy(){
    window.localStorage.removeItem('oneMember')
  }
}
</script>

<style lang="less" scoped>
@url: 'https://fileqn.anttalk.vip/';
.oneUser{
  .list-header{
    display: flex;
    padding: 10px 12px;
    .img-con{
      display: inline-flex;
      justify-content: center;
      align-items: center;
      width: 50px;
      height: 50px;
      position: relative;
      img{
        display: block;
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
      .vip-icon{
        position: absolute;
        width: 13px;
        height: 19px;
        bottom: 0px;
        right: 3px;
      }
      .vip1{
        background: url("@{url}FqvdyKzdOvhFc6yeHGCISPDh3Mq6") no-repeat 50% 50%;
        background-size: 99%;
      }
      .vip2{
        background: url("@{url}FmQsU_Ysx0rOaBp38p192_OKtyAY") no-repeat 50% 50%;
        background-size: 99%;
      }
      .vip3{
        background: url("@{url}Fn5_XQKTUnolmg_YGwNoqvaFFy6J") no-repeat 50% 50%;
        background-size: 99%;
      }
    }
    .text-con{
      flex: 1;
      display: inline-flex;
      flex-direction: column;
      overflow: hidden;
      padding-left: 15px;
      .name{
        color: rgb(43,43,43);
        font-size: 14px;
        margin: 10px 0 5px;
      }
      .date{
        color: rgb(136,136,136);
        font-size: 12px;
      }
    }
  }
  .list-con{
    position: fixed;
    overflow: auto;
    height: 100%;
    width: 100%;
    .list-title{
      line-height: 1;
      padding: .373rem .3rem;
      color: rgb(43,43,43);
      font-size: 16px;
      box-shadow: 0 1px 0 0 rgba(9,9,9,0.03);
      .blue{
        color: rgb(43,134,204);
        font-size: 16px;
        padding: 0 12px;
      }
    }
    .list{
      display: flex;
      /*padding: .2rem;*/
      box-shadow: 0 1px 0 0 rgba(9,9,9,0.03);
      height: 44px;
      .img-con{
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 46px;
        .icon-img{
          display: block;
          width: 19px;
          height: 28px;
        }
        .icon-img-1{
          background: url("@{url}FqvdyKzdOvhFc6yeHGCISPDh3Mq6") no-repeat 50% 50%;
          background-size: 19px 28px;
        }
        .icon-img-2{
          background: url("@{url}FmQsU_Ysx0rOaBp38p192_OKtyAY") no-repeat 50% 50%;
          background-size: 19px 28px;
        }
        .icon-img-3{
          background: url("@{url}Fn5_XQKTUnolmg_YGwNoqvaFFy6J") no-repeat 50% 50%;
          background-size: 19px 28px;
        }
      }
      .text-con{
        flex: 1;
        display: inline-flex;
        flex-direction: column;
        justify-content: center;
        overflow: hidden;
        .text{
          color: #242424;
          font-size: 14px;
          .num{
            padding: 0 16px;
          }
          .blue{
            color: #2b86cc;
            padding-left: 6px;
          }
        }

      }
    }
    .line{
      height: .4rem;
      background: rgba(9,9,9,0.03);
    }
  }
}
</style>